module.exports = __webpack_public_path__ + "img/mile6-m@1.3ab0e626.webp";